const getQueries = () => {
  return {}
}

export default getQueries
